import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "panel", "hint"]
    static values = { allocataire: Number }

    connect() {
        this.toggle()
    }

    toggle() {
        const v = this.selectTarget.value

        // Compatible valeur enum (ex: "7") et valeur string (ex: "allocataire")
        const isAllocataire =
            v === "allocataire" || Number(v) === this.allocataireValue

        this.setVisible(this.panelTarget, isAllocataire)
        this.setVisible(this.hintTarget, isAllocataire)
    }

    setVisible(el, visible) {
        if (!el) return
        el.style.display = visible ? "" : "none"
    }
}
